import type { ContentReferenceContext } from '@gitbook/app-database';
import { annotation, INLINE_LINK } from '@gitbook/doc-core';
import type { HiveClient } from '@gitbook/hive-client';
import type { PaletteHandle } from '@gitbook/react-uikit';
import type { EditorContainer } from '@gitbook/slate-react';

import { highlightSelection } from '../common';
import { createLinkPalette } from '../link/util';

export const toggleMark =
    ({ type, editor }: { type: string; editor: EditorContainer }) =>
    () => {
        editor.change((change) => {
            change.toggleMark(type);
            change.focus();
        });
    };

/*
 * Click to insert a link/mention
 */
export function toggleLink(props: {
    palette: PaletteHandle;
    editor: EditorContainer;
    contentReferenceContext: ContentReferenceContext;
    isInLink: boolean;
    hiveClient: HiveClient;
}) {
    const { palette, editor, contentReferenceContext, isInLink, hiveClient } = props;
    return () => {
        // If we are in a link, we remove it
        if (isInLink) {
            editor.change((change) => {
                change
                    .unwrapInline({
                        type: INLINE_LINK,
                    })
                    .focus();
            });
            return;
        }

        editor.change((change) => {
            highlightSelection(change);
        });

        const contentRefPaletteDefinition = createLinkPalette({
            editor,
            hiveClient,
            contentReferenceContext,
        });

        palette.open(contentRefPaletteDefinition);
        /**
         * Also return the definition if we want to use it in a command
         * trigger.
         */
        return contentRefPaletteDefinition;
    };
}

/**
 * Create callback to toggle an annotation.
 */
export const toggleAnnotation =
    ({ editor }: { editor: EditorContainer }) =>
    () => {
        editor.change((change) => {
            annotation.wrapWithAnnotation(change);
        });
    };
